export const NAV_OPTIONS = [
  {
    path: '/dashboard',
    icon: {
      name: 'home',
      color: 'secondary'
    },
    label: 'Home'
  },
  {
    path: '/dashboard/personal-info',
    icon: {
      name: 'personal',
      color: 'info'
    },
    label: 'Personal Info'
  },
  {
    path: '/dashboard/password-management',
    icon: {
      name: 'password',
      color: 'success'
    },
    label: 'Password Management'
  },
  {
    path: '/dashboard/security-and-sign-in',
    icon: {
      name: 'security',
      color: 'success'
    },
    label: 'Security & sign-in'
  }
]

export const ADMIN_NAV_OPTIONS = [
  {
    path: '/admin',
    icon: {
      name: 'home',
      color: 'secondary'
    },
    label: 'Home'
  },
  {
    path: '/admin/users',
    icon: {
      name: 'users',
      color: 'info'
    },
    label: 'Users'
  },
  {
    path: '/admin/clients',
    icon: {
      name: 'clients',
      color: 'info'
    },
    label: 'Clients'
  },
  {
    path: '/admin/invites',
    icon: {
      name: 'invites',
      color: 'success'
    },
    label: 'Invitations'
  },
  {
    path: '/admin/settings',
    icon: {
      name: 'settings',
      color: 'primary'
    },
    label: 'Settings'
  }
]

// Mirrors OPENID_SCOPES in the auth service, which creates these without read or write permissions.
// The scopes listing does not say which permissions belong to which scope, so the page has to know.
export const OPENID_SCOPES = ['openid', 'profile', 'email']
